import { createBrowserHistory } from 'history'

// Android WebViews do not properly track history on SPAs
export const AppHistory = createBrowserHistory()
